import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=3711065e&scoped=true&"
import script from "./BaseTag.vue?vue&type=script&lang=js&"
export * from "./BaseTag.vue?vue&type=script&lang=js&"
import style0 from "./BaseTag.vue?vue&type=style&index=0&id=3711065e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711065e",
  null
  
)

export default component.exports